export default "__VITE_ASSET__Bq$ZohDz__"